import { Heart } from "../Svg";

export default function Footer() {
    const currentYear = new Date().getFullYear();


    return (
        <div className="flex flex-col items-center bg-[#171717] p-4 text-center">
            <div className="mb-2">
                <p className="text-[#6a6a6a] text-[12px]">
                    Mainnet Build 1.14.0-a358996e0
                </p>
            </div>

            {/* Second Column */}
            <div className="">
                <p className="flex gap-[5px] text-white text-[12px] font-[400px]">
                    Made with <span className="text-[#ff0000]">{Heart}</span> <span>by the MultiversX team, {currentYear}</span> 
                </p>
            </div>
        </div>
    );
}
